import { combineReducers } from "redux";
import AllSavedPrescriptionsSlice from "./AllSavedPrescriptionsSlice";
import GetTicketsSlice from "./GetTicketsSlice";
import LoginSlice from "./LoginSlice";
import NotificationSlice from "./NotificationSlice";
import GetInitialTicketSlice from "./InitializeTicket";
import SavedPrescriptionSlice from "./SavedPrescriptionSlice";
import EPCSQueueSlice from "./EPCSQueueSlice";
import MedicationHistorySlice from "./MedicationHistorySlice";
import PostDatedPresCountSlice from "./PostDatedPresCountSlice";
import PostDatedPresDetailsSlice from "./PostDatedPresDetailsSlice";
import AllergiesSlice from "./AllergiesSlice";
import FavDrugsSlice from "./FavDrugsSlice";
import EPAHoldingQueueCountSlice from "./EPAHoldingQueueCountSlice";
import EPAHoldingQueueDetailsSlice from "./EPAHoldingQueueDetailsSlice";
import EPAWorklistCountSlice from "./EPAWorklistCountSlice";
import EPAWorklistDetailsSlice from "./EPAWorklistDetailsSlice";
import PrescriberDetailsSlice from "./PrescriberDetailsSlice";
import FavoritePharmacyDataListSlice from "./FavoritePharmacyDataListSlice";
import DrugSearchAjaxSlice from "./DrugSearchAjaxSlice";
import RxChangeAlertsSlice from "./RxChangeAlertsSlice";
import RxChangeAlertsDetailsSlice from "./RxChangeAlertsDetailsSlice";
import RxFillAlertsCountSlice from "./RxFillAlertsCountSlice";
import RxFillAlertsDetailsSlice from "./RxFillAlertsDetailsSlice";
import RefillAlertsCountSlice from "./RefillAlertsCountSlice";
import RefillAlertsListSlice from "./RefillAlertsListSlice";
import GlobalDropdownSlice from "./GlobalDropdownSlice";
import RxAlertsCountSlice from "./RxAlertsCountSlice";
import RxAlertsDetailsSlice from "./RxAlertsDetailsSlice";
import PatientDetailsSlice from "./PatientDetailsSlice";
import TopRibbonSlice from "./TopRibbonSlice";
import UserServicesSlice from "./UserServicesSlice";
import LogoutSlice from "./LogoutSlice";
import PharmacyDropDownSlice from "./PharmacyDropDownSlice";
import ClinicDisableSlice from "./ClinicDisableSlice";
import IdmeSlice from "./IdmeSlice";

const RootSlice = combineReducers({
  LoginSlice,
  LogoutSlice,
  NotificationSlice,
  AllSavedPrescriptionsSlice,
  GetTicketsSlice,
  GetInitialTicketSlice,
  SavedPrescriptionSlice,
  EPCSQueueSlice,
  MedicationHistorySlice,
  PostDatedPresCountSlice,
  AllergiesSlice,
  PostDatedPresDetailsSlice,
  FavDrugsSlice,
  EPAHoldingQueueCountSlice,
  EPAHoldingQueueDetailsSlice,
  EPAWorklistCountSlice,
  EPAWorklistDetailsSlice,
  PrescriberDetailsSlice,
  FavoritePharmacyDataListSlice,
  DrugSearchAjaxSlice,
  RxChangeAlertsSlice,
  RxChangeAlertsDetailsSlice,
  RxFillAlertsCountSlice,
  RxFillAlertsDetailsSlice,
  RefillAlertsCountSlice,
  RefillAlertsListSlice,
  GlobalDropdownSlice,
  RxAlertsCountSlice,
  RxAlertsDetailsSlice,
  PatientDetailsSlice,
  TopRibbonSlice,
  PharmacyDropDownSlice,
  UserServicesSlice,
  ClinicDisableSlice,
  IdmeSlice,
});

export default RootSlice;
